import { render } from "./App.vue?vue&type=template&id=15c3f9f3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=15c3f9f3&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__